import { Injectable } from '@angular/core';
import { MortgageSessionData } from '../interfaces/mortgage-session-data.interface';
import { MortgageBorrowerDataModel } from './mortgage-borrower-data/mortgage-borrower-data.model';
import { SessionStorageService } from '../../shared/session/session-storage/session-storage.service';
import { SessionableMortgageDataModel } from '../sessionable-mortgage-data-model';
import {
  CreateMortgageLoanApplicationRequest,
  MortgageReEntryStateData
} from '../../../../models/index';
import MortgageLoanPurpose = CreateMortgageLoanApplicationRequest.LoanPurposeEnum;

@Injectable()
export class MortgageSessionDataModel extends SessionableMortgageDataModel implements MortgageSessionData {

  // Data that is saved to session storage
  private _loanPurpose: MortgageLoanPurpose;
  private _mortgageId: string;
  private _loanState: MortgageReEntryStateData.MortgageReEntryStateEnum;
  private _leadNumber: string;
  private _loanApplicationGuid: string;

  constructor(
    protected sessionStorageService: SessionStorageService,
    private _borrowerData: MortgageBorrowerDataModel) {
    super(sessionStorageService);
  }

  public populate(model?: MortgageSessionDataModel): MortgageSessionDataModel {
    this._borrowerData.populate(model ? model._borrowerData : null);
    this._loanPurpose = model ? model._loanPurpose : null;
    this._loanState = model ? model.loanState : null;
    this._mortgageId = model ? model._mortgageId : '';
    this._leadNumber = model ? model._leadNumber : '';
    this._loanApplicationGuid = model ? model.loanApplicationGuid : '';
    return this;
  }

  protected map(model: MortgageSessionDataModel): MortgageSessionDataModel {
    return model;
  }

  protected save(setter: (model: MortgageSessionDataModel) => void): void {
    super.save(setter);
  }

  public set borrowerData(value: MortgageBorrowerDataModel) {
    this._borrowerData = value;
    this.save(x => x._borrowerData = value);
  }

  public get borrowerData(): MortgageBorrowerDataModel {
    return this._borrowerData;
  }

  public set loanPurpose(value: MortgageLoanPurpose) {
    this._loanPurpose = value;
    this.save(x => x._loanPurpose = value);
  }

  public get loanPurpose(): MortgageLoanPurpose {
    return this._loanPurpose;
  }

  public set mortgageId(value: string) {
    this._mortgageId = value;
    this.save(x => x._mortgageId = value);
  }

  public get mortgageId(): string {
    return this._mortgageId;
  }

  public set loanState(value: MortgageReEntryStateData.MortgageReEntryStateEnum) {
    this._loanState = value;
    this.save(x => x._loanState = value);
  }

  public get loanState(): MortgageReEntryStateData.MortgageReEntryStateEnum {
    return this._loanState;
  }

  public set leadNumber(value: string) {
    this._leadNumber = value;
    this.save(x => x._leadNumber = value);
  }

  public get leadNumber(): string {
    return this._leadNumber;
  }

  public set loanApplicationGuid(value: string) {
    this._loanApplicationGuid = value;
    this.save(x => x._loanApplicationGuid = value);
  }

  public get loanApplicationGuid(): string {
    return this._loanApplicationGuid;
  }
}
